import { FillStar } from "ui/Icon/DSIcon/FillStar"
import { Flex } from "antd"
import { Text } from "ui/Typography"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"
import styles from "./index.module.css"

const EmptyStateUI = ({ isSearch }) => {
  const { t } = useTranslation()
  return (
    <Flex vertical align="center" className={styles.emptyState} justify="center" gap={spacings.XL}>
      <FillStar />
      {isSearch ? (
        <Text>{t("reviews.no_search_review")}</Text>
      ) : (
        <Flex vertical align="center" gap={spacings.XS}>
          <Text size="lg" fw={500}>
            {t("reviews.no_reviews")}
          </Text>
          <Text>{t("reviews.reviews_displayed")}</Text>
        </Flex>
      )}
    </Flex>
  )
}

EmptyStateUI.propTypes = {
  isSearch: PropTypes.bool.isRequired
}

export default EmptyStateUI
